import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateCustomer } from '../services/customers';
import type { UpdateCustomerInput } from '../types/customers.types';
import { customerKeys } from './customerKeys';

/** Deliberately not optimistic: a holder detail change is a legal fact on a live
 *  contract, so it is shown only once the server holds it. */
export function useUpdateCustomerMutation(id: string) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (input: UpdateCustomerInput) => updateCustomer(id, input),
        // The agreement itself has not changed and customer_snapshot is immutable
        // by design, so no agreementKeys prefix is invalidated.
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: customerKeys.detail(id) });
            void queryClient.invalidateQueries({ queryKey: customerKeys.amendments(id) });
        },
    });
}
